import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment.development';
//import { RuntimeConfigService } from './runtime-config.service';
import { cleanText } from 'pdf-lib';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  private readonly privateKey: any;
  private readonly secrateKey: any;

  constructor() {
    this.privateKey = CryptoJS.enc.Utf8.parse(environment.PrivateKey);
    this.secrateKey = CryptoJS.enc.Utf8.parse(environment.SecrateKey);
    // this.privateKey = CryptoJS.enc.Utf8.parse(
    //   this.configService.config.PrivateKey,
    // );
    // this.secrateKey = CryptoJS.enc.Utf8.parse(
    //   this.configService.config.SecrateKey,
    // );
  }

  encrypt(inputText: any): any {   
    var encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(inputText),
      this.privateKey,
      {
        keySize: 128 / 8,
        iv: this.secrateKey,
      },
    );
    //
    return encodeURIComponent(encrypted.toString());
  }

  decrypt(inputText: string) {
    var decrypted = CryptoJS.AES.decrypt(inputText, this.privateKey, {
      keySize: 128 / 8,
      iv: this.secrateKey,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  
}
